// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__mohrFont_e860ea', '__mohrFont_Fallback_e860ea'"},"className":"__className_e860ea","variable":"__variable_e860ea"};